import './misc/globals'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueToastr from 'vue-toastr'

Vue.prototype.$toastr = VueToastr
Vue.use(VueToastr, {
  defaultTimeout: 2000
})

Vue.component('ClipLoader', require('vue-spinner/src/ClipLoader.vue').default)
Vue.component('PulseLoader', require('vue-spinner/src/PulseLoader.vue').default)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
